import $ from 'jquery';
import axios from 'axios';

const FUSER_HOST = "https://fuser.medibuddy.in";
const PROCHECK_HOST = "https://stg-integration-plus.medibuddy.in/Locus/GetRequestBasicDetails?requestId=T_URL";
const LOCATION_SERVICE_HOST = "https://location-service.medibuddy.in";

var SalDataManager = {};

function getPlatformName(uA) {
	if (["Chrome"].indexOf(uA) !== -1) return 'Google Chrome';
	if (["Firefox"].indexOf(uA) !== -1) return 'Mozilla Firefox';
	if (["Safari"].indexOf(uA) !== -1) return 'Safari';
	if (["Opera"].indexOf(uA) !== -1) return 'Opera';
	if (["Edge"].indexOf(uA) !== -1) return 'Microsoft Edge';
	return 'Other'
}

function getOS() {
	var userAgent = window.navigator.userAgent,
		platform = window.navigator.platform,
		macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
		windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
		iosPlatforms = ['iPhone', 'iPad', 'iPod'],
		os = null;
	if (macosPlatforms.indexOf(platform) !== -1) {
		os = 'Mac OS';
	} else if (iosPlatforms.indexOf(platform) !== -1) {
		os = 'iOS';
	} else if (windowsPlatforms.indexOf(platform) !== -1) {
		os = 'Windows';
	} else if (/Android/.test(userAgent)) {
		os = 'Android';
	} else if (!os && /Linux/.test(platform)) {
		os = 'Linux';
	}
	return os;
}

function getVersion(nAgt) {
	var verOffset, ix;
	var fullVersion = '' + parseFloat(window.navigator.appVersion);
	// In Opera, the true version is after "Opera" or after "Version"
	if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
		fullVersion = nAgt.substring(verOffset + 6);
		if ((verOffset = nAgt.indexOf("Version")) !== -1) fullVersion = nAgt.substring(verOffset + 8);
	}
	// In MSIE, the true version is after "MSIE" in userAgent
	else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
		fullVersion = nAgt.substring(verOffset + 5);
	}
	// In Chrome, the true version is after "Chrome" 
	else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
		fullVersion = nAgt.substring(verOffset + 7);
	}
	// In Safari, the true version is after "Safari" or after "Version" 
	else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
		fullVersion = nAgt.substring(verOffset + 7);
		if ((verOffset = nAgt.indexOf("Version")) !== -1)
			fullVersion = nAgt.substring(verOffset + 8);
	}
	// In Firefox, the true version is after "Firefox" 
	else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
		fullVersion = nAgt.substring(verOffset + 8);
	}
	// In most other browsers, "name/version" is at the end of userAgent 
	else if ((verOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
		fullVersion = nAgt.substring(verOffset + 1);
	}
	if ((ix = fullVersion.indexOf(";")) !== -1) fullVersion = fullVersion.substring(0, ix);
	if ((ix = fullVersion.indexOf(" ")) !== -1) fullVersion = fullVersion.substring(0, ix);
	return fullVersion
}

// function getFormattedCurrentDate() {
// 	let d = new Date();
// 	return (d.getDate() < 10 ? "0" + d.getDate() : d.getDate()) + "-" + (d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1) + "-" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
// }

function getAllState() {
	return $.ajax({
		url: PROCHECK_HOST + "/getAllState",
		method: "GET"
	});
}

function getSubGeo(payload) {
	return $.ajax({
		url: PROCHECK_HOST + "/getSubGeo",
		method: "POST",
		headers: {
			'Content-Type': 'application/json'
		},
		data: JSON.stringify(payload),
	});
}

function getAllDiagnosticCenters(payload) {
	return $.ajax({
		url: PROCHECK_HOST + "/getAllDiagnosticCenter",
		method: "POST",
		data: JSON.stringify(payload),
		headers: {
			'Content-Type': 'application/json'
		},
	})
}

function createAppointment(payload) {
	return axios.post(
		`${FUSER_HOST}/api/v1/request/generic/createAppointment`,
		JSON.stringify(payload),
		{ 
			headers: { 
				'Content-Type': 'application/json' 
			} 
		}
	);
};

async function fetchData(message, requestId) {
	const payload = {
		id: requestId,
		message: message
	};

	const response = await axios.post(
		`${FUSER_HOST}/api/v1/sal/fetchData`,
		JSON.stringify(payload),
		{
			headers: {
				'Content-Type': 'application/json'
			}
		}
	);
	return response.data;
}

async function updateStatus(body) {
	return await axios.post(
		`${FUSER_HOST}/api/v1/sal/updateStatus`,
		JSON.stringify(body),
		{
			headers: {
				'Content-Type': 'application/json'
			}
		}
	);
}

async function postActivity(capture) {
	if (capture.EventType === "Landed_on_unbooked_page_v2") {
		let platformpld = {}
		let navigator = window.navigator;
		let uA = navigator.userAgent.replace(/, /g, '_');
		let platformName = getPlatformName(uA);
		platformpld.platformOS = getOS();
		platformpld.platformName = platformName;
		platformpld.platformVersion = getVersion(navigator.userAgent);
		platformpld["alreadyBooked"] = capture.EventPayload["alreadyBooked"]
		capture.EventPayload = JSON.stringify(platformpld)
	}
	capture.EventLabel = capture.campaignId;
	capture.Channel = capture.campaignMode;

	return await axios.post(
		`${FUSER_HOST}/api/v1/events/provider/capturev2`,
		JSON.stringify(capture),
		{
			headers: {
				'Content-Type': 'application/json'
			}
		}
	);
}
async function getPincodeDetails(payload) {
	try {
		const response = await axios.post(
			`${FUSER_HOST}/api/v1/booking/getPincodeDetails`,
			JSON.stringify(payload),
			{ 
				headers: { 
					'Content-Type': 'application/json' 
				} 
			}
		);

		return response.data;
	} catch (error) {
		return null;
	}
}

function isHomeVisit(payload) {
	return $.ajax({
		url: FUSER_HOST + "/api/v1/booking/isCityAvailableForHomeVisit",
		method: "POST",
		data: JSON.stringify(payload),
		headers: {
			'Content-Type': 'application/json'
		}
	});
}

function getNearestDCForBooking(data, isCenterVisit) {
	const url = isCenterVisit ? `${FUSER_HOST}/api/v1/booking/getServiceableDCsForDCVisit` : `${FUSER_HOST}/api/v1/booking/getServiceableDCsForHomeVisit`;
	return axios.post(
		url,
		JSON.stringify(data),
		{
			headers: {
				'Content-Type': 'application/json',
			}
		}
	);
}

function getCitiesByStateId(stateId) {
	return axios.get(
		`${FUSER_HOST}/api/v1/booking/getServicableCitiesByStateId?stateId=${stateId}`
	);
}

async function getInBoundNumberByErId(erId) {
	try {
		const response = await axios.post(
			`${FUSER_HOST}/api/v1/sal/getInboundNumber`,
			{ ER_Id: erId },
			{ headers: { 'Content-Type': 'application/json' } }
		);

		return {
			inboundNumber: response.data.inboundNumber
		};
	} catch (error) {
		return {
			inboundNumber: '080-68239362'
		};
	}
}

async function getAvailableSlots(payload) {
	try {
		const response = await axios.post(
			`${FUSER_HOST}/slots/availableSlotsV2`,
			payload,
			{
				headers: {
				"Content-Type": "application/json",
				},
			}
		);
	
		return response.data;
	} catch (error) {
		return {
			availableSlots: false
		}
	}
}

function generateSal(payload) {
	return axios.post(
		`${FUSER_HOST}/api/v1/sal/generate`,
		payload,
		{
			headers: { 
				'Content-Type': 'application/json' 
			}
		}
	);
}

async function fetchPincodeFromCoordinates(latitude, longitude) {
	try {
		const response = await axios.post(
			`${LOCATION_SERVICE_HOST}/location-from-latlong`,
			{
				latitude,
				longitude
			},
			{
				headers: {
					'Content-Type': 'application/json',
					'x-mb-source': 'fuser-salcampaign',
					'x-mb-api-key': 'F8C01323-1FF0-4FD2-B999-5A13E64D719B'
				}
			}
		);
		return response.data?.result?.pincode;
	} catch (error) {
		return '';
	}
}

SalDataManager.getAllState = getAllState;
SalDataManager.getSubGeo = getSubGeo;
SalDataManager.createAppointment = createAppointment;
SalDataManager.updateStatus = updateStatus;
SalDataManager.getAllDiagnosticCenters = getAllDiagnosticCenters;
SalDataManager.postActivity = postActivity;
SalDataManager.fetchData = fetchData;
SalDataManager.isHomeVisit = isHomeVisit;
SalDataManager.getPincodeDetails = getPincodeDetails;
SalDataManager.getNearestDCForBooking = getNearestDCForBooking;
SalDataManager.getCitiesByStateId = getCitiesByStateId;
SalDataManager.getInBoundNumberByErId = getInBoundNumberByErId;
SalDataManager.getAvailableSlots = getAvailableSlots;
SalDataManager.generateSal = generateSal;
SalDataManager.fetchPincodeFromCoordinates = fetchPincodeFromCoordinates;

export default SalDataManager;